module.exports = __webpack_public_path__ + "static/img/chain_boss.6aa3077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chain_boss.png
// module id = FSQi
// module chunks = 2